export const ResultsList = [
  {
    img:
      "https://a0.muscache.com/im/pictures/ba85bc18-6acd-4106-b11d-01c7d440a31a.jpg?im_w=960",
    city: "Private room in center of Montreal",
    title: "Stay at this spacious Le Vacancier",
    description:
      "4 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine",
    star: "4.73",
    price: "$30 / night",
    total: "$117 total",
    url: "LaVacancier",
    name: "Le Vacancier",
    stars: "4.56",
    reviews: "6",
    location: "Montreal, Québec, Canada",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/women/1.jpg",
    host: "Nancy",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/ba85bc18-6acd-4106-b11d-01c7d440a31a.jpg?im_w=960",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/98cb0a06-325f-4f52-97a7-a9d70da27e27.jpg?im_w=480",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/e4625b59-7cb9-46b1-8467-32045e2635ca.jpg?im_w=480",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/d8a540cf-cf11-4b93-acb7-9229aa7ddd3e.jpg?im_w=480",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/bfdf6384-ed1c-4572-9848-19ca9c75086a.jpg?im_w=480",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/ba85bc18-6acd-4106-b11d-01c7d440a31a.jpg?im_w=960",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/4a11ae2d-ec80-45db-93fe-974803a44ae7.jpg?im_w=1200",
    city: "Private room in center of London",
    title: "Independant luxury studio Mount Royal",
    description:
      "2 guest · 3 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen",
    star: "4.3",
    price: "$40 / night",
    total: "$157 total",
    url: "MountRoyal",
    name: "mini chalet 1 chbre avec accès au lac",
    stars: "4.56",
    reviews: "6",
    location: "Saint-Tite, Québec, Canada",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/men/66.jpg",
    host: "Alex",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/4a11ae2d-ec80-45db-93fe-974803a44ae7.jpg?im_w=1200",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/f450a1cf-4879-4391-836d-c1eac1eeaf8f.jpg?im_w=1440",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/f474b096-f1f3-4f7a-a5d8-bd924accbbaf.jpg?im_w=1440",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/03fe9506-484e-487c-b954-617bd9cfd554.jpg?im_w=1440",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/cc2fbe96-66a8-423d-b59f-faececa6398c.jpg?im_w=1440",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/83a3b87b-d521-46d5-a9b2-c7b0a5ca9c1c.jpg?im_w=1440",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/miso/Hosting-28436865/original/72ebf44f-8b7e-4f18-ae7b-a5c80c45acc7.jpeg?im_w=1200",
    city: "Private room in center of Tornoto",
    title: "Ultra Luxury Treehouse.",
    description:
      "4 guest · 4 bedroom · 4 bed · 2 bathrooms · Free parking · Washing Machine",
    star: "3.8",
    price: "$35 / night",
    total: "$207 total",
    url: "Tornoto",
    name: "Ultra Luxury Treehouse. Cable Bridge and Waterfall",
    stars: "4.56",
    reviews: "6",
    location: "Adirondack, Remsen, New York, United States",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/men/25.jpg",
    host: "Tyron",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/miso/Hosting-28436865/original/72ebf44f-8b7e-4f18-ae7b-a5c80c45acc7.jpeg?im_w=1200",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/2cf71969-e76b-48a4-8540-3da9c25cefd2.jpg?im_w=1200",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/1a3a43bc-0513-4a54-93d8-ee80a4afa6ed.jpg?im_w=1200",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/562006f6-b14d-4c32-aeda-f900dffc7a42.jpg?im_w=1200",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/6059efeb-ff0a-4ab3-8891-ac201dc76fc6.jpg?im_w=1200",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/1e465e3f-c7ac-45f4-a3d0-692c9fbe08cd.jpg?im_w=1200",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/f9b6c336-7dbb-4c97-b3e0-4df7b53de9fb.jpg?im_w=1200",
    city: "Private room in center of Lac-Beauport",
    title: "Private room in center of Lac-Beauport",
    description:
      "4 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine",
    star: "4.73",
    price: "$30 / night",
    total: "$117 total",
    url: "4",
    name: "Tiny home hideaway",
    stars: "4.56",
    reviews: "6",
    location: "Lac-Beauport, Quebec, Canada",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/men/92.jpg",
    host: "Cheng",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/f9b6c336-7dbb-4c97-b3e0-4df7b53de9fb.jpg?im_w=1200",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/3528ca95-b122-4dfa-bc3f-774db0fbdbc2.jpg?im_w=720",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/635fe817-192a-402c-ab32-40d54d9c3389.jpg?im_w=720",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/6e404a29-2984-4ed4-85c9-b1fdb89494a2.jpg?im_w=720",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/0a622b7c-048b-4119-b8f3-cd5b5a3d5f50.jpg?im_w=720",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/dd023775-4a12-4f2d-8d5a-f710b93e48fb.jpg?im_w=1200",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/df395b96-609b-4d13-b379-22cd56a2582b.jpg?im_w=1200",
    city: "Private room in center of Lac-Beauport",
    title: "Stay at this spacious Lac-Beauport",
    description:
      "4 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine",
    star: "4.73",
    price: "$30 / night",
    total: "$117 total",
    url: "5",
    name: "Le LAÔ",
    stars: "4.56",
    reviews: "6",
    location: "Lac-Beauport, Quebec, Canada",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/men/74.jpg",
    host: "Mike",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/df395b96-609b-4d13-b379-22cd56a2582b.jpg?im_w=1200",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/miso/Hosting-43264966/original/73de3745-4099-44bb-ab09-ae93d69226d0.jpeg?im_w=1200",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/miso/Hosting-43264966/original/4ac04732-29c2-4d34-b912-1cba66428c66.jpeg?im_w=1200",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/miso/Hosting-43264966/original/136ae149-5197-455d-95f2-887052a545cf.jpeg?im_w=1200",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/miso/Hosting-43264966/original/fa808d7d-d94f-4a94-abb3-6caa89f2258b.jpeg?im_w=1200",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/miso/Hosting-43264966/original/3aadf36d-f8f7-477b-bfad-f71cae75d7d3.jpeg?im_w=1200",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/c78a011d-3845-4ad8-9ea2-1c0d3233686c.jpg?im_w=960",
    city: "Private room in center of Gatineau",
    title: "Stay at this spacious Gatineau",
    description:
      "4 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine",
    star: "4.73",
    price: "$30 / night",
    total: "$117 total",
    url: "6",
    name: "Sarah's Cabin",
    stars: "4.56",
    reviews: "6",
    location: "Gatineau, Québec, Canada",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/women/0.jpg",
    host: "Sarah",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/c78a011d-3845-4ad8-9ea2-1c0d3233686c.jpg?im_w=960",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/305bded0-c514-4aed-8aca-b9984ca12f73.jpg?im_w=1200",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/634a88a1-bfd2-47ea-9c67-5c41852d886b.jpg?im_w=1200",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/40157620-c090-479c-aad6-136fe54e33da.jpg?im_w=1200",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/6a53fc79-7537-40ce-a21b-4fa689e9071b.jpg?im_w=1200",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/168dea29-613e-4643-84ca-55e90a79a250.jpg?im_w=1200",
  },
  {
    img:
      "https://a0.muscache.com/im/pictures/55efbdaf-9a22-47a9-ae65-35fd4c89a32b.jpg?im_w=960",
    city: "Private room in center of New York",
    title: "Stay at this spacious Cabin",
    description:
      "4 guest · 1 bedroom · 1 bed · 1.5 shared bthrooms · Wifi · Kitchen · Free parking · Washing Machine",
    star: "4.73",
    price: "$30 / night",
    total: "$117 total",
    url: "7",
    name: "Cabin get-away to Lake George",
    stars: "4.56",
    reviews: "6",
    location: "Queensbury, New York, United States",
    degree: "36",
    food: "Free Food",
    host__img: "https://randomuser.me/api/portraits/men/35.jpg",
    host: "Johnny",
    guest: "4",
    bedroom: "1",
    bed: "1",
    bath: "1",
    wind: "5.2",
    reviewed: "85",
    imageUrl:
      "https://a0.muscache.com/im/pictures/55efbdaf-9a22-47a9-ae65-35fd4c89a32b.jpg?im_w=960",
    imageUrl2:
      "https://a0.muscache.com/im/pictures/3d049fd6-86da-4e70-bff6-abfaa227c3df.jpg?im_w=1200",
    imageUrl3:
      "https://a0.muscache.com/im/pictures/54c0a460-f198-4c21-99f8-f9970e05670f.jpg?im_w=1200",
    imageUrl4:
      "https://a0.muscache.com/im/pictures/a286c269-c09e-4f1a-99ad-033ec7eac5ee.jpg?im_w=1200",
    imageUrl5:
      "https://a0.muscache.com/im/pictures/aee512d6-e30c-4a27-8940-72bcbf0a971c.jpg?im_w=1200",
    imageUrl6:
      "https://a0.muscache.com/im/pictures/ef6fa1ad-ea05-4ca0-8fb3-f34f34532e5d.jpg?im_w=1200",
  },
];
